import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.js\",\"import\":\"Plus_Jakarta_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"300\",\"500\",\"700\"],\"style\":[\"normal\",\"italic\"],\"display\":\"swap\",\"fallback\":[\"Arial\",\"sans-serif\"],\"variable\":\"--font-transport-new\"}],\"variableName\":\"plusJakarta\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/Banner/Banner.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/MapsScript.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/footer/Autoeinfachlos_logo_weiss.webp");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/client/AuthProviderClient.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/client/CookieProviderClient.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/client/NavbarShell.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/client/ToastifyClient.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Footer/Footer.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Navbar/Navbar.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/context/DealerVehicleMarketProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/context/DealerWebActivityProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["FilterProvider"] */ "/vercel/path0/src/context/FilterContext.js");
